// @ts-nocheck

import { useEffect, useState } from 'react';

const loadImage = (path) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.addEventListener(
      'load',
      function onLoad() {
        img.removeEventListener('load', onLoad, false);
        resolve(img);
      },
      false,
    );

    img.addEventListener(
      'error',
      function onError() {
        img.removeEventListener('error', onError, false);
        reject();
      },
      false,
    );
    img.src = path;
  });
};

const useLoadImage = (src) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    let didCancel = false;

    (async () => {
      try {
        await loadImage(src);
        if (!didCancel) {
          setLoaded(true);
        }
      } catch (error) {
        console.warn('Some critical images are not available:', error);
        setError(true);
      }
    })();
    return () => {
      didCancel = true;
    };
  }, [src]);
  return {
    loaded,
    error,
  };
};

export default useLoadImage;
